export default '/static/frontend/ReachDigital/12gobiking/dist/assets/iban-dk-87e81c4a.png'